import styled from 'styled-components'

import { spacing } from '../../themes'

export const Content = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: ${spacing(5)};
`
